$('.front-graphic').each(function (index, el) {
  $(el).attr('data-index', (index + 1));
})

// var el = document.querySelector('.product-readmore');
//
// $(el).click(function(ev) {
//   var elHeight = el.scrollHeight;
//   $(this).toggleClass('read-more');
//   $(this).css({'height': $(this).hasClass('read-more') ? elHeight : ''});
// });

// Toggle read-more when clicking #product-link
$('#product-link').click(function() {
  $(el).toggleClass('read-more');
  var elHeight = el.scrollHeight;
  $(el).css({'height': $(el).hasClass('read-more') ? elHeight : ''});
});

$(document).ready(function () {
  function adjustThumbnailHeight() {
    if ($(window).width() <= 699) {
      var carouselHeight = $('.product-gallery__carousel').outerHeight();
      $('.product-gallery__thumbnail-list').css('height', carouselHeight);
    } else {
      $('.product-gallery__thumbnail-list').css('height', ''); // Reset height on larger screens
    }
  }

  // Run on page load
  adjustThumbnailHeight();

  // Run on window resize
  $(window).resize(function () {
    adjustThumbnailHeight();
  });
});


$(document).ready(function () {
  function adjustThumbnailHeightNew() {
    if ($(window).width() >= 700) {
      var carouselHeight = $('.product-gallery__image-list').outerHeight();
      $('.product-gallery__thumbnail-scroller').css('height', carouselHeight);
    } else {
      $('.product-gallery__thumbnail-scroller').css('height', ''); // Reset height on larger screens
    }
  }

  // Run on page load
  adjustThumbnailHeightNew();

  // Run on window resize
  $(window).resize(function () {
    adjustThumbnailHeightNew();
  });
});
